import { mapApplications, getTotalLicenceCount } from './Licences';

export { mapApplications, getTotalLicenceCount };

export default mapApplications;
